const getMallIntegration = async ({ params, api }) => {
  return await api(`mallIntegration/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getMallIntegration;
